import InfoIcon from "@mui/icons-material/Info";

import { LabelValue } from "../../components/LabelValue";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductCultureShockLevelMetaDataProps = {
    cultureShockLevel: string;
};

export function ProductCultureShockLevelMetaData({ cultureShockLevel }: ProductCultureShockLevelMetaDataProps) {
    const [t] = useProductTranslation();
    const label = t("label.cultureShockLevel");
    return (
        <LabelValue label={label} Icon={InfoIcon}>
            {cultureShockLevel}
        </LabelValue>
    );
}
